import { requireService } from '@profgeosoft/di-ez';
import { BackLight, DellDuotone } from '@repo/go-icons';
import { Button } from '@repo/go-ui';

import { wrap } from 'src/packages/mobx-di/wrap';

import type { GridRenderCellParams } from '@repo/go-table';
import type { DirectoryRecord } from 'src/services/directory-service/entities/directory-record.entity';

import styles from './record-buttons.module.scss';

interface IDirectoryService {
  getRecordById(id: number | string): DirectoryRecord | null;
  deleteRecord(record: DirectoryRecord): void;
  resetRecord(record: DirectoryRecord): void;
}

type Props = {
  params: GridRenderCellParams<DirectoryRecord>;
  directory: IDirectoryService;
};

export const RecordButtons = wrap<Props>(function RecordButtons({ params, directory }) {
  const { isEditing } = requireService('directoryPage');
  const record = directory.getRecordById(params.row.recordId);

  if (!record) {
    console.warn('record is not presented');
    return null;
  }

  if (isEditing) {
    switch (record.recordChangeState) {
      case 'new': {
        return (
          <Button
            variant="flat"
            icon={<DellDuotone className={styles.deleteRecordIcon} />}
            onClick={() => directory.deleteRecord(record)}
          />
        );
      }

      case 'hasChanges': {
        return (
          <Button
            variant="flat"
            icon={<BackLight className={styles.resetRecordIcon} />}
            onClick={() => directory.resetRecord(record)}
          />
        );
      }
    }
  }

  return null;
});
